import { transformIconData } from '../transformers/icon-url';
const TeamLinkIcons = async (_, args, context, info) => {
  const requestBody = args.teamLinkUrls.map(url => ({
    resourceUrl: url
  }));
  const options = {
    method: 'POST',
    body: JSON.stringify(requestBody)
  };
  return context.fetch(`${context.url.stargateRoot}/object-resolver/resolve/batch`, options).then(res => res.json()).then(transformIconData);
};
export default TeamLinkIcons;